import AbsComponent from '../../common/components/AbsComponent';
import Utils from '../../common/Utils';

/**
 * UserState class
 * @category mainApp
 */
class ModalLayer extends AbsComponent{
	constructor(_store={}, _el=''){
		super(_store, _el);
		this.render();
	}

	render() {

		if( $(this.el).length === 0){
			return false;
		}

		if(window._device === 'ingame'){
			return false;
		}

		const CookieName = $(this.el)[0].getAttribute('data-cookie');

		let cookieShow = Utils.getCookie(CookieName) !== 'hide';

		// console.log(CookieName);
		// console.log(Utils.getCookie(CookieName));
		// console.log($(this.el + ' button.btn-close'));


		if(Utils.getCookie(CookieName) !== 'hide'){
			$(this.el).show();
			$(this.el + ' button.btn-close').on('click', (e)=>{ // x 버튼 아이콘 클릭 시
				$(this.el).remove();
			});
			$(this.el + ' button.btn-hide').on('click', (e)=>{ // 일주일간 or 하루동안 보지않기 체크 클릭 시
				let expireDays = $(this.el + ' button.btn-hide')[0].id;
				Utils.setCookie(CookieName, 'hide', expireDays);
				$(this.el).remove();
			});
		}


	}

}

export default ModalLayer;